import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from "react-router-dom";


const SectionActivity = (props) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div className="flex-grow-1">
                        </div>
                        <div className="mt-3 mt-lg-0">
                            <form action="#">
                                <Row className="g-3 mb-0 align-items-center">
                                    <div className="col-auto">
                                        <button
                                            type="button"
                                            className="btn btn-label btn-primary"
                                            onClick={props.rightCanvasBtn} // Added onClick event handler here
                                        >
                                            <i className="ri-filter-fill label-icon"></i> Filtros
                                        </button>
                                    </div>
                                </Row>
                            </form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default SectionActivity;